<div class="centre-spinner" *ngIf="count | async">
        <p-progressSpinner></p-progressSpinner>
</div>